import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { UserCreatedOrgData } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { PersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.service';
import { FilterDataOption } from 'src/app/moov-common/services/utils/utils-data';

@Component({
  selector: 'app-team-view-filters',
  templateUrl: './team-view-filters.component.html',
  styleUrls: ['./team-view-filters.component.scss']
})
export class TeamViewFiltersComponent extends BaseComponent implements OnInit {
  @Input() filterDataList : FilterDataOption[] = [];
  @Input() filterHeader: string;
  orgListLoaded : boolean = true;
  selectedId : string = "";
  

  constructor(private readonly psersonalUserService:PersonalUserDataService,
    private dialogRef: MatDialogRef<TeamViewFiltersComponent>){
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  changeSelection (value : string) {
    this.selectedId = value;
}

  submit(): void {
    this.dialogRef.close(this.selectedId);
  }

  close(): void {
    this.dialogRef.close(undefined);
  }
}